import { format, isThisYear, isToday, isYesterday } from 'date-fns'

export function formatDateTime(dateString: string | null | undefined, timeZone?: string, locale: string = "en-GB") {
  if (!dateString) return "—";

  const date = new Date(dateString);

  if (isNaN(date.getTime()) || date.getFullYear() < 1900) {
    return "—";
  }

  return date.toLocaleString(locale, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    ...(timeZone ? { timeZone } : {})
  });
}

export function formatTimeShort(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

export function formatRelativeDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime()) || d.getFullYear() < 1900) return '—'

  const time = format(d, 'h:mm a')
  if (isToday(d)) return `Today, ${time}`
  if (isYesterday(d)) return `Yesterday, ${time}`
  return `${isThisYear(d) ? format(d, 'MMM d') : format(d, 'MMM d, yyyy')}, ${time}`
}

export function formatDate(dateString: string | null | undefined, timeZone?: string, locale: string = "en-GB") {
  if (!dateString) return "—";

  // Date-only strings (YYYY-MM-DD) are calendar dates, not instants — parse as
  // local midnight and skip the timezone shift, so "2026-06-10" never renders as
  // the previous day in a behind-UTC account.
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(dateString);
  const date = dateOnly ? new Date(`${dateString}T00:00:00`) : new Date(dateString);

  // Handle invalid dates or default/empty dates (year 1 or before 1900)
  if (isNaN(date.getTime()) || date.getFullYear() < 1900) {
    return "—";
  }

  return date.toLocaleDateString(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
    ...(timeZone && !dateOnly ? { timeZone } : {})
  });
}